import {
  Archive,
  ArchiveRestore,
  ArrowDownToLine,
  ArrowLeftRight,
  Ban,
  Check,
  CloudUpload,
  Code,
  Copy,
  Download,
  Eye,
  EyeOff,
  GripVertical,
  History,
  Link,
  LogOut,
  Maximize2,
  Minimize2,
  Minus,
  MoveVertical,
  Pause,
  Pencil,
  Play,
  Plus,
  Zap,
  RefreshCcw,
  RefreshCw,
  Repeat,
  RotateCw,
  Search,
  SendHorizontal,
  Settings,
  SlidersHorizontal,
  Square,
  Trash,
  Trash2,
  Unlink,
  WandSparkles,
  X,
} from 'lucide-react';
import { createLucideIcon } from '../createLucideIcon';

// Action / editing icons. Names match the previous @mui/icons-material names
// so call sites only change their import path.
export const AddIcon = /* #__PURE__ */ createLucideIcon('Add', Plus);
export const RemoveIcon = /* #__PURE__ */ createLucideIcon('Remove', Minus);
export const CloseIcon = /* #__PURE__ */ createLucideIcon('Close', X);
export const CheckIcon = /* #__PURE__ */ createLucideIcon('Check', Check);
export const EditIcon = /* #__PURE__ */ createLucideIcon('Edit', Pencil);
export const DeleteIcon = /* #__PURE__ */ createLucideIcon('Delete', Trash2);
export const DeleteOutlineIcon = /* #__PURE__ */ createLucideIcon('DeleteOutline', Trash2);
export const DeleteForeverIcon = /* #__PURE__ */ createLucideIcon('DeleteForever', Trash);
export const ContentCopyIcon = /* #__PURE__ */ createLucideIcon('ContentCopy', Copy);
export const SearchIcon = /* #__PURE__ */ createLucideIcon('Search', Search);
export const RefreshIcon = /* #__PURE__ */ createLucideIcon('Refresh', RefreshCw);
export const CachedIcon = /* #__PURE__ */ createLucideIcon('Cached', RefreshCcw);
export const SyncIcon = /* #__PURE__ */ createLucideIcon('Sync', RefreshCw);
export const AutorenewIcon = /* #__PURE__ */ createLucideIcon('Autorenew', RotateCw);
export const RepeatIcon = /* #__PURE__ */ createLucideIcon('Repeat', Repeat);
export const RestoreIcon = /* #__PURE__ */ createLucideIcon('Restore', History);
export const ArchiveIcon = /* #__PURE__ */ createLucideIcon('Archive', Archive);
export const UnarchiveIcon = /* #__PURE__ */ createLucideIcon('Unarchive', ArchiveRestore);
export const DownloadIcon = /* #__PURE__ */ createLucideIcon('Download', Download);
export const DownloadOutlinedIcon = /* #__PURE__ */ createLucideIcon('DownloadOutlined', Download);
export const FileDownloadIcon = /* #__PURE__ */ createLucideIcon('FileDownload', ArrowDownToLine);
export const FileDownloadOutlinedIcon = /* #__PURE__ */ createLucideIcon(
  'FileDownloadOutlined',
  ArrowDownToLine,
);
export const CloudUploadIcon = /* #__PURE__ */ createLucideIcon('CloudUpload', CloudUpload);
export const SendIcon = /* #__PURE__ */ createLucideIcon('Send', SendHorizontal);
export const TuneIcon = /* #__PURE__ */ createLucideIcon('Tune', SlidersHorizontal);
export const BlockIcon = /* #__PURE__ */ createLucideIcon('Block', Ban);
export const StopIcon = /* #__PURE__ */ createLucideIcon('Stop', Square);
export const PlayArrowIcon = /* #__PURE__ */ createLucideIcon('PlayArrow', Play);
export const PauseIcon = /* #__PURE__ */ createLucideIcon('Pause', Pause);
// MUI Minimize is a single bottom bar; Lucide's closest glyph is a plain minus.
export const MinimizeIcon = /* #__PURE__ */ createLucideIcon('Minimize', Minus);
export const OpenInFullIcon = /* #__PURE__ */ createLucideIcon('OpenInFull', Maximize2);
export const CloseFullscreenIcon = /* #__PURE__ */ createLucideIcon('CloseFullscreen', Minimize2);
export const SwapHorizIcon = /* #__PURE__ */ createLucideIcon('SwapHoriz', ArrowLeftRight);
export const DragIndicatorIcon = /* #__PURE__ */ createLucideIcon('DragIndicator', GripVertical);
export const HeightIcon = /* #__PURE__ */ createLucideIcon('Height', MoveVertical);
export const TouchAppIcon = /* #__PURE__ */ createLucideIcon('TouchApp', Zap);
export const AutoFixHighIcon = /* #__PURE__ */ createLucideIcon('AutoFixHigh', WandSparkles);
export const VisibilityIcon = /* #__PURE__ */ createLucideIcon('Visibility', Eye);
export const VisibilityOffIcon = /* #__PURE__ */ createLucideIcon('VisibilityOff', EyeOff);
export const LinkIcon = /* #__PURE__ */ createLucideIcon('Link', Link);
export const LinkOffIcon = /* #__PURE__ */ createLucideIcon('LinkOff', Unlink);
export const LogoutIcon = /* #__PURE__ */ createLucideIcon('Logout', LogOut);
export const SettingsIcon = /* #__PURE__ */ createLucideIcon('Settings', Settings);
export const CodeIcon = /* #__PURE__ */ createLucideIcon('Code', Code);
